module.exports = __webpack_public_path__ + "img/70.0b1f685e.jpg";